<template>
  <div class="d-flex flex-column pa-2">
    <div class="d-flex justify-space-between align-center">
      <div>
        <StatutLivraisonChip :etat-logistique="resumeContrat.etatLogistique" />
      </div>
      <div
        v-if="!isTresoMoissonAFixer"
        :class="hasDocumentPdf ? '' : 'disabled'"
        class="d-flex justify-end align-center cliquable"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div
              :class="$vuetify.breakpoint.mobile ? 'mt-3 d-flex justify-center' : ''"
              v-on="on"
            >
              <AgrButton
                :disabled="!hasDocumentPdf || loading.document"
                target="_blank"
                text
                @click="onDownloadClick"
              >
                <BaseLoader v-if="loading.document" />
                <v-img
                  v-else
                  class="ma-2 icon"
                  src="@/assets/download/grey-tray-arrow-down.svg"
                />
                <span
                  v-show="!isTresoMoissonAFixer"
                  class="text-truncate texte texte-gris-fonce"
                >PDF</span>
              </AgrButton>
            </div>
          </template>
          {{ tooltipPdf }}
        </v-tooltip>
      </div>
    </div>
    <div class="d-flex align-center flex-wrap">
      <span
        v-if="!isTresoMoissonAFixer"
        class="secondary--text titre-h3 font-weight-bold pr-4 pb-2"
      >
        {{ titreAffiche | capitalize }}
      </span>
      <TresoMoissonChip
        v-if="isTresoMoisson"
        :class="isTresoMoissonAFixer ? 'mt-2 mb-2': '' "
        :is-a-fixer="isTresoMoissonAFixer"
      />
      <StatutUtilisationChip
        v-if="isEchangeCereales && resumeContrat.etatUtilisation.code !== 'INCONNU'"
        :etat-utilisation="resumeContrat.etatUtilisation"
      />
    </div>
    <div class="d-flex">
      <span
        v-if="!isContratNonEngage && !isTresoMoissonAFixer"
        class="texte-gris-fonce texte"
      >
        Souscrit le {{ resumeContrat.dateSouscription | date('dd/MM/yyyy') }} - N°{{ resumeContrat.numeroContrat }}
      </span>
      <span
        v-else
        class="py-2"
      />
    </div>
    <div
      v-if="isContratNonEngage"
      class="d-flex align-center pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Poids livré
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ resumeContrat.quantiteLivreeEnKg / 1000 | roundNumber(2) }} t
      </span>
    </div>
    <div
      v-if="isTresoMoissonAFixer"
      :class="$vuetify.breakpoint.mobile ? '' : 'align-center'"
      class="d-flex  pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Poids à fixer
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ quantiteTresoMoissonAFixer / 1000 | roundNumber(2) }} t
      </span>
    </div>
    <div
      v-if="!isTresoMoissonAFixer"
      class="d-flex pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Poids contrat
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ resumeContrat.quantiteCibleEnKg / 1000 | roundNumber(2) }} t
      </span>
    </div>
    <v-divider v-if="isEchangeCereales" />
    <div
      v-if="isEchangeCereales"
      class="d-flex align-center pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Poids restant à utiliser
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ resumeContrat.quantiteEchangeRestantEnKg / 1000 | roundNumber(2) }} t
      </span>
    </div>
    <v-divider v-if="!isEchangeCereales && resumeContrat.prixBaseEnEuroParTonne" />
    <div
      v-if="!isEchangeCereales && resumeContrat.prixBaseEnEuroParTonne"
      class="d-flex pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Prix de contrat {{ isPrixProvisoire ? 'provisoire' : '' }}
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ resumeContrat.prixBaseEnEuroParTonne | roundNumber(2) }} €/t
      </span>
    </div>
    <v-divider v-if="isTresoMoissonAFixer && resumeContrat.prixAcompteTresoMoissonAFixerEnEuroParTonne" />
    <div
      v-if="isTresoMoissonAFixer && resumeContrat.prixAcompteTresoMoissonAFixerEnEuroParTonne"
      class="d-flex pt-2 justify-space-between"
    >
      <span class="intro texte-gris-fonce py-3">
        Prix d'avance
      </span>
      <span class="titre-h4 py-2 align-end secondary--text">
        {{ resumeContrat.prixAcompteTresoMoissonAFixerEnEuroParTonne | roundNumber(2) }} €/t
      </span>
    </div>
    <v-divider v-if="displayEtatPaiement" />
    <div
      class="d-flex pt-2 justify-space-between"
    >
      <span
        class="intro texte-gris-fonce"
        :class="displayEtatPaiement ? 'py-3' : 'py-6'"
      >
        {{ displayEtatPaiement ? 'État du règlement' : '' }}
      </span>
      <span
        class="titre-h4  align-end secondary--text"
        :class="displayEtatPaiement ? 'py-2' : 'py-6'"
      >
        {{ displayEtatPaiement ? resumeContrat.etatPaiement.libelle : '' | capitalize }}
      </span>
    </div>
    <div
      v-if="isTresoMoissonAFixer"
      class="pt-5"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <AgrButton
            outlined
            large
            block
            @click="onDetailsClick"
          >
            Plus d'infos
          </AgrButton>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <AgrButton
            large
            block
            @click="toBag()"
          >
            <div class="d-flex justify-center">
              <span class="action white--text ml-4 ml-md-0 mr-2">
                Vendre
              </span>
              <v-icon
                color="white"
                class="mr-4 mr-md-0"
                size="20"
              >
                mdi-open-in-new
              </v-icon>
            </div>
          </AgrButton>
        </v-col>
      </v-row>
      <div class="d-flex justify-end mr-10 action-medium texte-gris-fonce">
        <span class="align-self-center pr-2">La vente se fera sur Bourse aux grains</span> <img
          class="align-self-center logo-bag"
          src="@/assets/icon-bag-ar.svg"
        >
      </div>
    </div>
    <div
      v-else
      class="pt-5"
    >
      <v-row>
        <v-col
          cols="12"
          :md="hasApports && resumeContrat.numeroContrat ? 6 : 12"
        >
          <AgrButton
            outlined
            large
            block
            @click="onDetailsClick"
          >
            Plus d'infos
          </AgrButton>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <AgrButton
            v-if="hasApports && resumeContrat.numeroContrat"
            large
            block
            @click="onApportsClick"
          >
            {{ resumeContrat.nbApports }} apport{{ resumeContrat.nbApports > 1 ? 's' : '' }}
          </AgrButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {isBefore, parse} from 'date-fns'
import {createUrl, downloadFile} from '@/utils/axios-helper'
import {AgrButton} from '@agrial/ui'
import {mapActions} from 'vuex'
import StatutLivraisonChip from './chip/statut-livraison-chip.vue'
import StatutUtilisationChip from './chip/statut-utilisation-chip.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import TresoMoissonChip from '@/views/detail-contrats/components/chip/treso-moisson-chip.vue'
import {sommeDesNombresDefinis} from '@/utils/math'

export default {
  name: 'ResumeContrat',
  components: {TresoMoissonChip, BaseLoader, AgrButton, StatutLivraisonChip, StatutUtilisationChip },
  props: {
    resumeContrat: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: {
        document: true
      },
      erreur: {
        document: false
      },
      documentPdf: null,
      tooltipPdf: 'Loading'
    }
  },

  computed: {
    hasDocumentPdf () {
      return !!this.documentPdf
    },

    titreAffiche () {
      return this.isTresoMoisson ? this.resumeContrat.type.categorieContrat : this.resumeContrat.type.sousTypeContrat
    },

    isPrixEnCoursConstruction () {
      const list = ['Prix campagne', 'Contrat filière', 'Prix par période']
      return list.includes(this.resumeContrat.type.categorieContrat)
    },

    isPrixProvisoire () {
      const anneeRecolte = Number(this.resumeContrat.anneeRecolte) + 1
      const formatDateLimite = anneeRecolte + '-07-01'
      const dateLimite = parse(formatDateLimite, 'yyyy-MM-dd', new Date())
      return this.isPrixEnCoursConstruction && isBefore(new Date(), dateLimite)
    },

    isTresoMoisson () {
      return this.resumeContrat.type.sousTypeContrat === 'Tréso Moisson'
    },

    isTresoMoissonAFixer () {
      return this.resumeContrat.type.code === 'TRESO_MOISSON_A_FIXER'
    },

    isContratNonEngage () {
      return this.resumeContrat.type.code === 'CAMPAGNE_NON_ENGAGE'
    },

    isPrixParPeriode () {
      return this.resumeContrat.type.categorieContrat !== 'Prix ferme'
    },

    isEchangeCereales () {
      return ['CTA', 'CCS'].includes(this.resumeContrat.type.code)
    },

    displayEtatPaiement () {
      return !this.isEchangeCereales && this.resumeContrat.etatPaiement.code !== 'INCONNU'
    },

    hasApports () {
      return this.resumeContrat.nbApports > 0
    },

     //TRESO MOISSON
     quantiteTresoMoissonTotal () {
      //Poids engagé
      return Number(sommeDesNombresDefinis(
       this.resumeContrat.quantiteTresoMoissonFixerEnKg,
        + this.quantiteTresoMoissonAFixer))
    },

    quantiteTresoMoissonAFixer () {
      return Number(sommeDesNombresDefinis(
       this.resumeContrat.quantiteTresoMoissonLivreeSansFixationEnKg,
        + this.resumeContrat.quantiteTresoMoissonEngageAFixerEnKg,
        - this.resumeContrat.quantiteTresoMoissonEnAttenteEnKg))
    },
  },

  created () {
    this.loadDocumentPDF()
  },

  methods: {
    ...mapActions({
      getDocumentPdf: 'contrat/getDocumentPdf',
      getDocumentFileName: 'contrat/getDocumentFileName'
    }),

    loadDocumentPDF () {
      this.loading.document = true

      if (this.resumeContrat.numeroContrat != null) {
        this.tooltipPdf = 'Chargement du document en cours.'
        this.getDocumentPdf(this.isPrixParPeriode && this.resumeContrat.codeContratASAP ? this.resumeContrat.codeContratASAP : this.resumeContrat.numeroContrat)
          .then(response => {
            this.documentPdf = response
            this.tooltipPdf = 'Consulter votre document de confirmation de vente.'
          })
          .catch(error => {
            if (error.response.data) {
              this.documentPdf = null
              if (error.response.status === 404) {
                this.tooltipPdf = 'Nous ne parvenons pas à trouver votre document de confirmation de vente.'
              } else {
                this.tooltipPdf = 'Erreur du serveur lors de la récupération du document.'
              }
            }
          })
          .finally(() => this.loading.document = false)
      } else {
        this.tooltipPdf = 'Pas de document pour ce type de contrat.'
        this.loading.document = false
      }
    },

    onDownloadClick () {
      if (this.hasDocumentPdf) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.getDocumentFileName(this.resumeContrat.numeroContrat)
            .then((filename) => {
              downloadFile(this.documentPdf, filename)
            })
        } else {
          const url = createUrl(this.documentPdf)
          window.open(url)
        }
      }
    },

    onDetailsClick () {
      this.$emit('onDetailsClick', this.resumeContrat)
    },

    onApportsClick () {
      this.$router.push({ name: 'main.mes-recoltes', params:{
        anneeRecolte: this.resumeContrat.anneeRecolte,
        codeGraineRs3: this.resumeContrat.codeGraineRs3,
        numeroContrat: this.resumeContrat.numeroContrat
      }})
    },
    toBag () {
      window.open(
        window.PROPERTIES.get('URL_BOURSE_AUX_GRAINS').toString()
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .align-end {
    text-align: end;
  }

  .icon {
    width: 1.5em;
  }

  .disabled {
    opacity: 0.5;
  }

  .cliquable {
    cursor: pointer;
  }

  .logo-bag {
  width: 1.5rem;
} 

</style>
